export default __webpack_public_path__ + "static/media/virtual-tour.7deb0822.png";